import { render, staticRenderFns } from "./apiDocument.vue?vue&type=template&id=ba8f14d4&scoped=true"
import script from "./apiDocument.vue?vue&type=script&lang=js"
export * from "./apiDocument.vue?vue&type=script&lang=js"
import style0 from "./apiDocument.vue?vue&type=style&index=0&id=ba8f14d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f14d4",
  null
  
)

export default component.exports